module.exports = __webpack_public_path__ + "img/service-stock-img.71e7566a.jpeg";